import { post, ServiceResult } from "@insite/client-framework/Services/ApiService";
import { ShipToModel } from "@insite/client-framework/Types/ApiModels";
import { AvalaraAddressResponseModel } from "@waytek/Types/AvalaraValidationModel";

const customAvalaraURL = "/api/v1/avalaraValidation";

export async function avalaraAddressValidationService(
    parameter: ShipToModel,
): Promise<ServiceResult<AvalaraAddressResponseModel>> {
    try {
        const validation = await post<ShipToModel, AvalaraAddressResponseModel>(`${customAvalaraURL}`, parameter);

        return {
            result: validation,
            successful: true,
        };
    } catch (error) {
        const tmpError = error as any;
        if ("status" in tmpError && tmpError.status === 400 && tmpError.errorJson) {
            const { btValidateAddressResponse, stValidateAddressResponse } = tmpError.errorJson;
            if (btValidateAddressResponse || stValidateAddressResponse) {
                return {
                    successful: false,
                    errorMessage: "Avalara validation error",
                };
            }
            if (tmpError.errorJson.message) {
                return {
                    successful: false,
                    errorMessage: tmpError.errorJson.message,
                };
            }
        }
        throw error;
    }
}
